export default __webpack_public_path__ + "static/media/cern-medium-italic.faa99ded.woff";